import { useQuery } from "@tanstack/react-query";
import { getEventsFilter } from "src/api/filters/filters";
import { MAX_PAGE_SIZE, MIN_PAGE } from "src/constants/size";
import { QUERYKEYS } from "src/types/queryKeys";

export const useGetEventsFilter = () => {
  const { isLoading, isError, data, isSuccess, refetch } = useQuery({
    queryKey: [QUERYKEYS.EVENTS_FILTER],
    queryFn: () =>
      getEventsFilter({
        size: MAX_PAGE_SIZE,
        page: MIN_PAGE,
      }),
    staleTime: 0,
  });

  return {
    isSuccess,
    data,
    isError,
    isLoading,
    refetchEvenetsFilter: refetch,
  };
};
